const base64Pattern = new RegExp(/^([A-Za-z0-9+/=]|\s)*$/);

/**
 * Answers for anything, not only for a string: a render result carries `image`
 * as `null` when the renderer produced no image, and callers reach for this
 * predicate to decide whether there is one to show.
 */
export function isBase64(input: string | null | undefined): boolean {
  if (typeof input !== 'string') {
    return false;
  }

  return base64Pattern.test(input) && input.length % 4 === 0;
}
